'use strict';

angular.module('AdminControllers', [
    'ngAnimate',
    'ui.bootstrap',
    'mgcrea.ngStrap',
    'angularMoment',
    'iamAdminControllers',
    'EmployeeEventControllers',
    'services.employees'
]);